export const SET_PRODUCT_COLLECTION_LAYOUT = 'SET_PRODUCT_COLLECTION_LAYOUT';

export const setProductCollectionLayout = layout => ({
  type: SET_PRODUCT_COLLECTION_LAYOUT,
  currentLayout: layout,
});
